// src/components/ThemeToggle.js

import React from 'react';
import { useTheme } from '../context/ThemeContext';
import './ThemeToggle.css';

const ThemeToggle = () => {
  const { theme, toggleTheme } = useTheme();

  return (
    <div className="theme-toggle-container">
      <div className="theme-toggle">
        <input
          type="checkbox"
          id="theme-toggle-input"
          className="theme-toggle-input"
          checked={theme === 'dark'}
          onChange={toggleTheme}
          aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}
        />
        <label htmlFor="theme-toggle-input" className="theme-toggle-label">
          <span className="toggle-icon light-icon" aria-hidden="true"></span>
          <span className="toggle-icon dark-icon" aria-hidden="true"></span>
          <span className="toggle-ball"></span>
        </label>
      </div>
    </div>
  );
};

export default ThemeToggle;
